// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Cta = require("../atom/Atom_Cta.bs.js");
var Atom_Row = require("../atom/Atom_Row.bs.js");
var Particle_zIndex = require("../particle/Particle_zIndex.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function Molecule_RedirectionAnchor$Button(Props) {
  var onClick = Props.onClick;
  var label = Props.label;
  return React.createElement(Atom_Cta.Button.make, {
              label: label,
              onClick: onClick,
              style: {
                TAG: /* Header */10,
                _0: /* RedirectionAnchor */3
              }
            });
}

var Button = {
  make: Molecule_RedirectionAnchor$Button
};

function Molecule_RedirectionAnchor$Link(Props) {
  var href = Props.href;
  var label = Props.label;
  var target = Props.target;
  return React.createElement(Atom_Cta.Link.make, {
              href: href,
              label: label,
              style: {
                TAG: /* Header */10,
                _0: /* RedirectionAnchor */3
              },
              target: target
            });
}

var Link = {
  make: Molecule_RedirectionAnchor$Link
};

function renderAction(action) {
  if (action === undefined) {
    return null;
  }
  if (action.NAME === "Link") {
    var match = action.VAL;
    return React.createElement(Molecule_RedirectionAnchor$Link, {
                href: match.href,
                label: match.label,
                target: match.target
              });
  }
  var match$1 = action.VAL;
  return React.createElement(Molecule_RedirectionAnchor$Button, {
              onClick: match$1.onClick,
              label: match$1.label
            });
}

function Molecule_RedirectionAnchor(Props) {
  var left = Props.left;
  var right = Props.right;
  var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
        CssJs.position(CssJs.absolute),
        Particle_zIndex.Particle_zIndex_Css.toCss({
              TAG: /* Exact */0,
              _0: /* RedirectionAnchor */11
            }),
        CssJs.focusWithin([Particle_zIndex.Particle_zIndex_Css.toCss({
                    TAG: /* Exact */0,
                    _0: /* RedirectionAnchorFocused */12
                  })])
      ]);
  var left$1 = renderAction(left);
  var right$1 = renderAction(right);
  return React.createElement(Atom_Row.make, {
              alignItems: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "stretch"),
              background: Particle_Background_Ds.header,
              children: null,
              height: Particle_Screen_Constants.oneHundredPctHeight,
              justifyContent: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "spaceAround"),
              rules: rules,
              width: Particle_Screen_Constants.oneHundredPctWidth,
              wrap: /* OnOneLine */1
            }, left$1, right$1);
}

Molecule_RedirectionAnchor.displayName = "RedirectionAnchor";

var make = Molecule_RedirectionAnchor;

exports.Button = Button;
exports.Link = Link;
exports.renderAction = renderAction;
exports.make = make;
/*  Not a pure module */
